export var FileType;
(function (FileType) {
    FileType["SET"] = "set";
    FileType["DRAWING"] = "drawing";
    FileType["SCRAPBOOK"] = "scrapbook";
    FileType["DOCUMENT"] = "document";
    FileType["SPECIFICATION"] = "specification";
    FileType["PHOTO"] = "photos";
    FileType["ALBUM"] = "album";
    FileType["FOLDER"] = "folder";
})(FileType || (FileType = {}));
export var FileStatus;
(function (FileStatus) {
    FileStatus["CREATED"] = "created";
    FileStatus["DELETED"] = "deleted";
})(FileStatus || (FileStatus = {}));
export var MarkupType;
(function (MarkupType) {
    MarkupType["TEXT"] = "text";
    MarkupType["SHAPE"] = "shape";
    MarkupType["CIRCLE"] = "circle";
    MarkupType["IMAGE"] = "image";
    MarkupType["DRAWING"] = "drawing";
    MarkupType["LINE"] = "line";
    MarkupType["ARROW"] = "arrow";
    MarkupType["POLYGON"] = "polygon";
    MarkupType["PEN"] = "pen";
    MarkupType["RFI"] = "rfi";
    MarkupType["FILTER"] = "filter";
    MarkupType["SUBMITTAL"] = "submittal";
    MarkupType["CLOUD"] = "cloud";
})(MarkupType || (MarkupType = {}));
